import { styled } from '@mui/system'

export const Cell = styled('div')`
    min-height: 60px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;

    .capitalize {
        text-transform: capitalize;
    }
`

export const SeverityCell = styled(Cell)`
    gap: 8px;
`

export const IssuesCell = styled(Cell)`
    gap: 8px;
`

export const IssueCountItem = styled('div')`
    display: flex;
    align-items: center;
    gap: 4px;

    svg {
        width: 14px;
        height: 14px;
    }
`
